"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeProxyServices = void 0;
const proxyServiceAxiosRepository_1 = require("./repositories/axios/proxyServiceAxiosRepository");
const proxyServiceImpl_1 = require("./services/proxyServiceImpl");
const initializeProxyServices = (services) => {
    services.proxy.proxyService = new proxyServiceImpl_1.ProxyServiceImpl(new proxyServiceAxiosRepository_1.ProxyServiceAxiosRepository(services.common.baseHttpService));
};
exports.initializeProxyServices = initializeProxyServices;
//# sourceMappingURL=proxyModule.js.map